import BrandsUsingTagContainer from './BrandsUsingTag.Container';

export default BrandsUsingTagContainer;
